/** Human-readable labels for enum values. */
import type { BodyStatSource, MealSource, MealType } from './types';

export const MEAL_LABEL: Readonly<Record<MealType, string>> = {
  breakfast: 'Breakfast', lunch: 'Lunch', dinner: 'Dinner', snack: 'Snacks',
  pre_workout: 'Pre-workout', post_workout: 'Post-workout', other: 'Other',
};

/** Default clock hour used when logging a meal on a day other than today. */
export const MEAL_HOUR: Readonly<Record<MealType, number>> = {
  breakfast: 8, lunch: 12, dinner: 18, snack: 15, pre_workout: 16, post_workout: 17, other: 12,
};

export const SOURCE_LABEL: Readonly<Record<MealSource, string>> = {
  manual: 'Manual', ai_text: 'AI · text', ai_image: 'AI · photo', usda: 'USDA', barcode: 'Barcode', recipe: 'Recipe',
};

export const BODY_SOURCE_LABEL: Readonly<Record<BodyStatSource, string>> = {
  scale: 'Scale', smart_scale: 'Smart scale', dexa: 'DEXA', bod_pod: 'Bod Pod', bia: 'BIA', calipers: 'Calipers', manual: 'Manual', estimate: 'Estimate',
};

/** Suggest a meal slot from the clock. */
export function mealTypeForNow(date: Date = new Date()): MealType {
  const h: number = date.getHours();
  if (h < 11) return 'breakfast';
  if (h < 15) return 'lunch';
  if (h < 17) return 'snack';
  if (h < 22) return 'dinner';
  return 'snack';
}
